import { Field } from 'formik';
import { FormikField } from '~/components/common/FormikField';
import { Panel } from '~/components/common/Panel';
import { GroupSelector } from '~/components/upload/lithostrat/group/GroupSelector';
import { LithostratOrderSelector } from '~/components/upload/lithostrat/LithostratOrderSelector';
import { LithostratTypeSelector } from '~/components/upload/lithostratType/LithostratTypeSelector';

export function FormationFormFields() {
  return (
    <div className="grid lg:grid-cols-3 gap-6">
      <div className="lg:col-span-2">
        <Panel>
          <Panel.Heading>
            <Panel.Title>Formation Details</Panel.Title>
          </Panel.Heading>

          <Panel.Body className="space-y-2">
            <Field
              name="name"
              label="Formation name"
              component={FormikField}
              required
            />
            <Field
              name="description"
              label="Description"
              component={FormikField}
              type="textarea"
              required
            />

            <div className="grid lg:grid-cols-3 gap-6">
              <div className="lg:col-span-2 space-y-2">
                <Field
                  name="lithostratTypeId"
                  label="Lithostrat Type"
                  component={FormikField}
                  type={LithostratTypeSelector}
                  required
                />
              </div>

              <div className="space-y-2">
                <Field
                  name="lithostratOrder"
                  label="Lithostrat Order"
                  component={FormikField}
                  type={LithostratOrderSelector}
                />
              </div>
            </div>

            <Field
              name="comments"
              label="Comments"
              component={FormikField}
              type="textarea"
            />
          </Panel.Body>
        </Panel>
      </div>

      <div>
        <Panel>
          <Panel.Heading>
            <Panel.Title>Group</Panel.Title>
          </Panel.Heading>
          <Panel.Body>
            <Field
              name="groupId"
              label="Group"
              component={FormikField}
              type={GroupSelector}
            />
          </Panel.Body>
        </Panel>
      </div>
    </div>
  );
}
